import React from 'react';

const SIZES = {
  sm: { fontSize: 'var(--text-sm)',   padding: '0 14px', height: 36, gap: 6 },
  md: { fontSize: 'var(--text-base)', padding: '0 20px', height: 44, gap: 8 },
  lg: { fontSize: 'var(--text-lg)',   padding: '0 28px', height: 54, gap: 10 },
};

function palette(variant) {
  switch (variant) {
    case 'secondary':
      return { '--bg': 'var(--human-400)', '--bg-press': 'var(--human-500)', '--fg': '#fff', '--bd': 'transparent' };
    case 'outline':
      return { '--bg': 'transparent', '--bg-press': 'var(--neutral-50)', '--fg': 'var(--ink)', '--bd': 'var(--ink)' };
    case 'ghost':
      return { '--bg': 'transparent', '--bg-press': 'var(--neutral-100)', '--fg': 'var(--ink)', '--bd': 'transparent' };
    case 'ink':
      return { '--bg': 'var(--neutral-900)', '--bg-press': 'var(--neutral-800)', '--fg': '#fff', '--bd': 'transparent' };
    default: // primary — acid green, ink text
      return { '--bg': 'var(--science-400)', '--bg-press': 'var(--science-500)', '--fg': 'var(--ink)', '--bd': 'transparent' };
  }
}

/** Primary action control. Pass `href` to render a link styled as a button. */
export default function Button({
  variant = 'primary', size = 'md', type = 'button', href, iconLeft, iconRight,
  disabled = false, block = false, style, children, ...rest
}) {
  const s = SIZES[size] || SIZES.md;
  const isOutline = variant === 'outline';
  const Tag = href ? 'a' : 'button';
  return (
    <Tag
      {...(href
        // Disabled anchors must not navigate: drop href, expose aria-disabled
        ? (disabled ? { role: 'button', 'aria-disabled': true } : { href, role: 'button' })
        : { type, disabled })}
      style={{
        ...palette(variant),
        display: block ? 'flex' : 'inline-flex',
        width: block ? '100%' : undefined,
        alignItems: 'center', justifyContent: 'center', gap: s.gap,
        height: s.height, padding: s.padding,
        fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)', fontSize: s.fontSize,
        letterSpacing: 'var(--track-tight)',
        color: 'var(--fg)', background: 'var(--bg)',
        border: isOutline ? '1.5px solid var(--bd)' : '1.5px solid transparent',
        borderRadius: 'var(--radius-pill)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.45 : 1,
        transition: 'background var(--dur-fast) var(--ease-out), transform var(--dur-fast) var(--ease-out)',
        whiteSpace: 'nowrap',
        textDecoration: 'none', boxSizing: 'border-box',
        ...style,
      }}
      onMouseDown={(e) => { if (!disabled) e.currentTarget.style.transform = 'scale(0.97)'; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.background = 'var(--bg-press)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--bg)'; e.currentTarget.style.transform = 'scale(1)'; }}
      {...rest}
    >
      {iconLeft}
      {children}
      {iconRight}
    </Tag>
  );
}
